import React from 'react';
import PropTypes from 'prop-types';
import { getStatusIndex } from './statusUtils';
import { formatDate } from './dateUtils';
import './statusProgressDots.scss';

// Define the status progression order
const STATUS_PROGRESSION = [
  'Received',
  'Contacting',
  'Scheduled',
  'Seen',
];

// Map step labels to status_dates keys
const STEP_DATE_KEYS = {
  Received: 'received_at',
  Contacting: 'contacting_at',
  Scheduled: 'scheduled_at',
  Seen: 'seen_at',
};

const getTooltip = (label, statusDates) => {
  if (!statusDates) return label;
  const dateVal = statusDates[STEP_DATE_KEYS[label]];
  return dateVal ? `${label} — ${formatDate(dateVal)}` : `${label} — Pending`;
};

const StatusProgressDots = ({ status, hasFinalStep, statusDates }) => {
  const steps = hasFinalStep !== false
    ? STATUS_PROGRESSION
    : STATUS_PROGRESSION.filter((s) => s !== 'Seen');
  const currentIndex = getStatusIndex(status);
  const isTerminal = currentIndex === -1;

  return (
    <div className="status-progress-dots">
      {steps.map((label, index) => {
        let dotClass = 'status-progress-dots__dot';

        if (isTerminal) {
          dotClass += ' status-progress-dots__dot--error';
        } else if (index < currentIndex) {
          dotClass += ' status-progress-dots__dot--completed';
        } else if (index === currentIndex) {
          dotClass += ' status-progress-dots__dot--active';
        } else {
          dotClass += ' status-progress-dots__dot--pending';
        }

        return (
          <React.Fragment key={label}>
            <span
              className={dotClass}
              title={getTooltip(label, statusDates)}
            />
            {index < steps.length - 1 && (
              <span
                className={`status-progress-dots__line ${
                  !isTerminal && index < currentIndex
                    ? 'status-progress-dots__line--completed'
                    : ''
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

StatusProgressDots.propTypes = {
  status: PropTypes.string.isRequired,
  hasFinalStep: PropTypes.bool,
  statusDates: PropTypes.object,
};

StatusProgressDots.defaultProps = {
  hasFinalStep: true,
  statusDates: null,
};

export default StatusProgressDots;
